
















































import {Component, Vue, Inject, Emit} from "vue-property-decorator";
import Antd from "ant-design-vue";
import AbpBase from "@/lib/abpbase";
import _ from "lodash";
import {API_GetSmsCaptcha, API_GetSmsCaptchaWx} from "@/api/login";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import Util from "@/lib/util";

@Component({
    components: {}
})
export default class wxMessage extends AbpBase {

    customActiveKey = '0'
    loginBtn = false
    // login type: 0 email, 1 username, 2 telephone
    loginType = 0
    isLoginError = false
    requiredTwoStepCaptcha = false
    stepCaptchaVisible = false

    state = {
        time: 60,
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        loginType: 0,
        smsSendBtn: false
    }

    loginModel = {
        userNameOrEmailAddress: "",
        password: "",
        loginType: '',
        rememberMe: false,
        vueInstance: this,
    };
    form: any;
    showChangeTenant: boolean = false;

    beforeCreate() {
        this.form = this.$form.createForm(this);
    }

    created() {
    }


    async handleSubmit(e) {
        var self = this;
        e.preventDefault();
        self.form.validateFields(async (err, values) => {
            if (err) {
                return ;
            }
            ajaxHelperInstance.get('/web/auth/checkCodeWx',values).then((res)=>{
                let {data,errno,message} = res.data;
                if(data.status==0){
                    let uuid = data.uuid;
                    self.register({uuid:uuid,mobile:values.mobile});
                }else{
                    setTimeout(()=>{
                        Util.abp.auth.setToken(data.access_token);
                        location.reload();
                    },2000)
                }
            })
        });
    }


    getCaptcha(e){
        e.preventDefault()
        const { form: { validateFields }, state } = this
        validateFields(['mobile'], { force: true }, (err, values) => {
            if (!err) {
                state.smsSendBtn = true

                const interval = window.setInterval(() => {
                    if (state.time-- <= 0) {
                        state.time = 60
                        state.smsSendBtn = false
                        window.clearInterval(interval)
                    }
                }, 1000);

                API_GetSmsCaptchaWx(values).then(res => {

                    let {data,errno,message} = res.data;
                    if(errno!=0){
                        this.$notification['info']({
                            message: '提示',
                            description: message,
                            duration: 8
                        })
                        return;
                    }
                    const hide:any = this.$message.loading('验证码发送中..', 0)
                    setTimeout(hide, 2500)
                }).catch(err => {
                    // setTimeout(hide, 1)
                    clearInterval(interval)
                    state.time = 60
                    state.smsSendBtn = false
                    this.requestFailed(err)
                })
            }
        })
    }
    requestFailed (err) {
        this.isLoginError = true
        this.$notification['error']({
            message: '错误',
            description: ((err.response || {}).data || {}).message || '请求出现错误，请稍后再试',
            duration: 4
        })
    }

    @Emit("register")
    register(data){
        return data;
    }


}
